/**
 * Start for me — navigation helpers for write / record flows.
 */
import { toast } from 'sonner';
import { personHref } from './prettyArchiveLinks';
import { setPendingStartForMe } from './startForMeStorage';

export function buildWriteNowHref(personId, prompt) {
  if (!personId) return null;
  setPendingStartForMe({
    action: 'write',
    promptId: prompt.id,
    mainPrompt: prompt.mainPrompt,
    followUps: prompt.followUps || [],
    suggestedChapter: prompt.suggestedChapter || '',
    personId,
  });
  return `${personHref({ id: personId })}?view=stories&startForMe=write`;
}

export function buildRecordVoiceHref(personId, prompt) {
  if (!personId) return null;
  setPendingStartForMe({
    action: 'record',
    promptId: prompt.id,
    mainPrompt: prompt.mainPrompt,
    followUps: prompt.followUps || [],
    suggestedChapter: prompt.suggestedChapter || '',
    personId,
  });
  return `${personHref({ id: personId })}?view=stories&focus=voice&startForMe=record`;
}

export function handoffWriteNow(navigate, personId, prompt) {
  const href = buildWriteNowHref(personId, prompt);
  if (!href) {
    toast.message('Open a person profile first', {
      description: 'Choose someone in your archive, or add yourself as a person, then write from Start for me.',
    });
    return false;
  }
  navigate(href);
  return true;
}

export function handoffRecordVoice(navigate, personId, prompt) {
  const href = buildRecordVoiceHref(personId, prompt);
  if (!href) {
    toast.message('Open a person profile first', {
      description: 'Choose someone in your archive to record a voice memory with this prompt.',
    });
    return false;
  }
  navigate(href);
  return true;
}
